import { scenes } from "../scenes";
import { CustomScene } from "../models";

export default new CustomScene(
  "TitleScene",
  scenes.LivingRoom(),
  require("@/audio/Main_Theme.mp3")
);
